export default "__VITE_ASSET__DoqALdng__"